import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {parseTag, RTag, TagModel} from './tagModel';

/*
 * Runtime type.
 */

const RSearchTagsDirty = t.readonly(
  t.type({
    limit: t.Integer,
    tags: t.readonlyArray(t.readonlyArray(RTag)),
  }),
);

/*
 * Type.
 */

export type SearchTagModel = ReadonlyArray<TagModel>;
export interface SearchTagsModel extends t.TypeOf<typeof RSearchTagsDirty> {}
export const RSearchTags = t.clean<SearchTagsModel>(RSearchTagsDirty as any);

/*
 * IO methods.
 */

export function parseSearchTags(src: any): SearchTagsModel {
  return {
    limit: src.limit,
    tags: src.tags && src.tags.map((tag: any) => parseSearchTag(tag)),
  };
}

function parseSearchTag(src: any): ReadonlyArray<TagModel> {
  const results: Array<TagModel> = [];
  let currentTagSrc = src;

  while (currentTagSrc) {
    results.push(parseTag(currentTagSrc));
    currentTagSrc = currentTagSrc.parent_tag;
  }

  return results;
}

/*
 * API type.
 */

export const ApiSearchTags = makeApiType('searchTags', RSearchTags, parseSearchTags);
